// src/utils/calculateComtax.js

export const calculateComtax = (commission, setComtax) => {
    if (commission) {
        const tax = commission * 19 / 100;
        return tax;
    }
    return 0;  // Return 0 if commission is not provided or is falsy
};
